import { gql } from '@apollo/client';

export const CREATE_STOCK_LOCATION = gql`
  mutation CreateStockLocation($portfolioId: ID!, $name: String!) {
    createStockLocation(portfolioId: $portfolioId, name: $name)
  }
`;

export const RENAME_STOCK_LOCATION = gql`
  mutation RenameStockLocation($portfolioId: ID!, $locationId: ID!, $name: String!) {
    renameStockLocation(portfolioId: $portfolioId, locationId: $locationId, name: $name)
  }
`;

export const DELETE_STOCK_LOCATION = gql`
  mutation DeleteStockLocation($portfolioId: ID!, $locationId: ID!) {
    deleteStockLocation(portfolioId: $portfolioId, locationId: $locationId)
  }
`;
